module.exports = __webpack_public_path__ + "assets/img/WechatIMG67.0714a023.png";